<mat-card class="clickable-container" [routerLink]="[link]">
  <mat-card-content>
    <div class="icon-text-vertical">
      <mat-icon class="icon-large">{{ icon }}</mat-icon>
      <span mat-card-subtitle class="label-large">{{ text }}</span>
    </div>
  </mat-card-content>
</mat-card>
